import { Anchor, Box, Image, Stack, Text } from '@mantine/core'
import styles from './SupportCard.module.css'

export type SupportCardProps = {
  cardTitle: string
  href: string
  image: {
    src: string
  }
  imageAlt: string
  imageStyling: React.CSSProperties
  children?: any
}

export default function SupportCard({ cardTitle, href, image, imageAlt, imageStyling, children }: SupportCardProps) {
  return (
    <Stack className={styles.supportCardContainer} gap="xs">
      <Anchor
        style={
          href === ''
            ? {
                cursor: 'default',
                pointerEvents: 'none',
              }
            : {}
        }
        target="_blank"
        href={href}
        underline="hover"
        c="gray.9"
      >
        <Stack justify="center" align="center">
          <Box className={styles.imageBox}>
            <Image src={image?.src} style={imageStyling} alt={imageAlt} />
          </Box>
          <Text fz="1.125rem" c="black" fw={700}>
            {cardTitle}
          </Text>
        </Stack>
      </Anchor>
      {children}
    </Stack>
  )
}
